import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FileMetaData } from '@modeso/types__aumico-lib-companies-be';

@Component({
    selector: 'upload-document',
    templateUrl: './upload-document.component.html',
    styleUrls: ['./upload-document.component.scss'],
})
export class UploadDocumentComponent implements OnInit {
    @Input() acceptedExtensions: string[] = [];
    @Input() maxSizeInMb: number;
    @Input() filesMetaData: Partial<FileMetaData>[] = [];
    @Input() multiUpload: boolean = false;

    @Output() fileUploaded = new EventEmitter<File>();
    @Output() fileSizeError = new EventEmitter<boolean>();

    public fileExtensionError = false;

    ngOnInit(): void {}

    public onFileUploadedChanged(event: FileList): void {
        this.fileExtensionError = false;
        if (!event || event.length === 0) {
            return;
        }
        for (let i = 0; i < event.length; i++) {
            const file = event.item(i);
            if (!file) {
                continue;
            }
            const extension = file.name.split('.').pop();
            // size validation
            if (this.maxSizeInMb && file.size > this.maxSizeInMb * 1024 * 1024) {
                this.fileSizeError.emit(true);
                continue;
            }
            // extension validation
            if (!this.acceptedExtensions.includes('.' + extension)) {
                this.fileExtensionError = true;
                continue;
            }
            // record metadata and emit file

            // If only single upload allowed, reset the filesMetaData array.
            // However the page must handle to only use the last emitted file!
            if (!this.multiUpload) {
                this.filesMetaData = [];
            }
            this.filesMetaData.push({ size: file.size, name: file.name });
            this.fileUploaded.emit(file);
            this.fileSizeError.emit(false);
        }
    }

    public onDrop(event: DragEvent): void {
        event.preventDefault();
        this.onFileUploadedChanged(event.dataTransfer.files);
    }

    public onDragOver(event: DragEvent): void {
        event.preventDefault();
        event.stopPropagation();
    }

    public resetFiles($event): void {
        $event.target.value = '';
    }
}
